module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger mr-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteschedulereportModal
    }
  }, [_vm._v("Delete Schedule")])]), _vm._v(" "), _c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.reportType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Report Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.reportType),
      expression: "schedulereport.reportType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "reportType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "reportType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getSelectiveStation]
    }
  }, [_c('option', {
    attrs: {
      "value": "logbook"
    }
  }, [_vm._v("Vehicle Log Book")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hcv_ms"
    }
  }, [_vm._v("Data HCV Mother Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hcv_dbs"
    }
  }, [_vm._v("Data HCV DB Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dsr"
    }
  }, [_vm._v("Daily Sales Report")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Report Type is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.downloadType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Download Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.downloadType),
      expression: "schedulereport.downloadType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "downloadType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "downloadType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PDF"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "XLSX"
    }
  }, [_vm._v("Excel")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "downloadType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Download Type is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.reportFrequency),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Report Frequency")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.reportFrequency),
      expression: "schedulereport.reportFrequency"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "reportFrequency"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "reportFrequency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.validateReportFrequency]
    }
  }, [_c('option', {
    attrs: {
      "value": "daily"
    }
  }, [_vm._v("Daily")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "weekly"
    }
  }, [_vm._v("Weekly")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportFrequency",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Report Frequency is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.status),
      expression: "schedulereport.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "scheduleStartDate"
    }
  }, [_vm._v("Schedule Start Date")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleStartDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('date-picker', {
    attrs: {
      "id": "scheduleStartDate",
      "lang": "en",
      "name": "scheduleStartDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.schedulereport.scheduleStartDate),
      callback: function($$v) {
        _vm.$set(_vm.schedulereport, "scheduleStartDate", $$v)
      },
      expression: "schedulereport.scheduleStartDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleStartDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Start date is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "scheduleEndDate"
    }
  }, [_vm._v("Schedule End Date")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleEndDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('date-picker', {
    attrs: {
      "id": "scheduleEndDate",
      "lang": "en",
      "name": "scheduleEndDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.schedulereport.scheduleEndDate),
      callback: function($$v) {
        _vm.$set(_vm.schedulereport, "scheduleEndDate", $$v)
      },
      expression: "schedulereport.scheduleEndDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleEndDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("End date is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.scheduleDay),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Schedule Day")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.scheduleDay),
      expression: "schedulereport.scheduleDay"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "scheduleDay",
      "disabled": _vm.disabledInput
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "scheduleDay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Sunday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Monday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Tuesday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Wednesday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Thursday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Friday")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Saturday")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleDay",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Schedule day is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.lastDays),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Last Days")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.lastDays),
      expression: "schedulereport.lastDays"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "scheduleDay"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "lastDays", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2 days")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3 days")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 days")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 days")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "reportTime"
    }
  }, [_vm._v("Report Generation Time")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.reportGenerationTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-timepicker', {
    staticStyle: {
      "width": "271px"
    },
    attrs: {
      "name": "reportGenerationTime",
      "required": ""
    },
    model: {
      value: (_vm.schedulereport.reportGenerationTime),
      callback: function($$v) {
        _vm.$set(_vm.schedulereport, "reportGenerationTime", $$v)
      },
      expression: "schedulereport.reportGenerationTime"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportGenerationTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Report Generation Time is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Report Filter")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.region),
      expression: "schedulereport.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getSites]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                                " + _vm._s(item.value) + "\n                                            ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("G.A is a required field")])])], 1)], 1), _vm._v(" "), (this.schedulereport.reportType != 'logbook') ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.station),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.station),
      expression: "schedulereport.station"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "station"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "station", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.station_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                                " + _vm._s(item.value) + "\n                                            ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "station",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location is a required field")])])], 1)], 1) : _vm._e(), _vm._v(" "), (this.schedulereport.reportType == 'logbook') ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schedulereport.vehicleId),
      expression: "schedulereport.vehicleId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "vehicleId",
      "disabled": _vm.disabledVehicleInput
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.schedulereport, "vehicleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Vehicle")]), _vm._v(" "), _vm._l((_vm.vehicle_no), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All Vehicles")])], 2)])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Report Recipients")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "emailTo"
    }
  }, [_vm._v(" To ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('vue-select', {
    attrs: {
      "label": "user",
      "multiple": "",
      "options": this.user_list,
      "searchable": true,
      "language": "en-US"
    },
    model: {
      value: (_vm.schedulereport.emailTo),
      callback: function($$v) {
        _vm.$set(_vm.schedulereport, "emailTo", $$v)
      },
      expression: "schedulereport.emailTo"
    }
  })], 1), _vm._v(" "), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": "emailCc"
    }
  }, [_vm._v(" CC ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('vue-select', {
    attrs: {
      "label": "user",
      "multiple": "",
      "options": this.user_list,
      "searchable": true,
      "language": "en-US"
    },
    model: {
      value: (_vm.schedulereport.emailCc),
      callback: function($$v) {
        _vm.$set(_vm.schedulereport, "emailCc", $$v)
      },
      expression: "schedulereport.emailCc"
    }
  })], 1)])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ReportSchedule'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.updateSchedule
    }
  }, [_vm._v("Update Schedule")])], 1)], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ad823d2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ad823d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/reportschedule/ReportScheduleDetails.vue
// module id = 2322
// module chunks = 0